import { HttpClientModule, HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { PatientPlan, Payment, ScheduledBhVisit, RequestVerification, ScheduledIntakeData, SavePatientSchedule, PatientScheduleIntakeData, WaitingRoom, ScheduleRequest } from '../models/index';
import { Api, ErrorHelper, Session, Ui, MessagingService, MessageEvent } from '../services/index';
import { PaymentMethod, PaymentMethodResult, IntakePaymentCharge } from '../models/sf-payments'
import { MyModal } from '../components/modal/modal';
import { Observable } from 'rxjs';
import { GoogleAnalyticsEventsService } from '../providers/google-analytics';
import {TranslateService} from '@ngx-translate/core'; 
declare var require: any
declare let ga: Function;
@Component({
  selector: 'app-exam-payment',
  templateUrl: './exam-form-of-payment.html',
  styleUrls: ['./exam-form-of-payment.css'],
  providers: [MessagingService],
  //styleUrls: ['../dashboard/dashboard-my-profile.css','./exam-form-of-payment.css']
})

export class ExamFormOfPayment implements OnInit {
  public autoDrivenPlaceholder: String;
  public autoDrivenPaymentPlaceholder: String = "Chose from your saved methods of payment";
  public localFields: Object = { text: 'name', value: 'planId' };
  public localPaymentFields: Object = { text: 'cardnumber', value: 'cardid' };
  public height: string = '250px';
  public watermark: string;
  paymentPlans: PatientPlan[] = [];
  authorizationCode: string = '';
  displayPayment: boolean = false;
  noPayment: boolean = false;
  orgPayment: Payment = new Payment;
  patientId: number;
  patientPlan: PatientPlan[] = [];
  payment: Payment = new Payment;
  paymentProcessed: boolean = false;
  selectedPlan: PatientPlan;
  updatePayment: boolean = false;
  scheduledIntakeforPatient: PatientScheduleIntakeData;
  loading: boolean = false;
  paymentMethods: Array<PaymentMethodResult> = [];
  defaultPaymentMethod: PaymentMethodResult;
  intakePayment: IntakePaymentCharge;
  intakeWaitingRoom: WaitingRoom;
  cardToEdit: PaymentMethodResult;
  scheduleBhVisit: ScheduledBhVisit;
  isSavedPayments: boolean = false;


  constructor(private api: Api,
    private route: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef,
    private errorHelper: ErrorHelper,
    private translateService: TranslateService,
    private messagingService: MessagingService,
    private router: Router,
    private service: NotificationsService,
    public session: Session,
    private ui: Ui) {
    this.patientId = this.route.snapshot.params['patientId'] || '';



  }


  ngOnInit() {
    //this.session.intakeBhType = 'PSI'

    if (this.session.intakeLob === 'UC') {
      this.getPlansForVisit();
    } else if (this.session.intakeLob === 'BH') {

      this.getPlansForVisitType(this.session.intakeBhType);

    }
    this.translateService.get('EXAM_PAYMENT.SELECT_MSG').subscribe((res: string) => {
      if(res){
        this.autoDrivenPlaceholder  = res;
      }else{
        this.autoDrivenPlaceholder  = 'Select Plan';
      }
    
      console.log(res);
    });    







    // //Connect to ms.
    // this.messagingService.start('EventHub', this.session.authorization.access_token)
    //   .then(() => { console.log('messagingService starting EventHub connection.'); })
    //   .catch((e) => {
    //     console.log('Error while establishing connection to EventHub:', e);
    //     // })
    //     // .finally(()=>{
    //     //   console.log('messagingService starting EventHub finally.');
    //   });
  }
//   ngAfterViewInit(e: any): void {
//     // call the change event's function after initialized the component.
//     setTimeout(()=>
//   {
//     this.onChange(e);
//  })
// }
  getPlansForVisitType(visitType) {
    this.loading = true;
    let plans = this.api.getPatientPoliciesByLineOfBusiness(this.patientId, visitType);
    plans.subscribe(response => {
      this.patientPlan = response;
      var bestPolicy = this.getBestPolicy(response);
      this.setPolicy(bestPolicy);
      if (!this.displayPayment) {
        this.selectedPlan = bestPolicy;
      }
      if (!this.changeDetectorRef['destroyed']) {
        this.changeDetectorRef.detectChanges();
      }

      this.api.getuserPaymentMethods(this.session.patientId).subscribe(payMethodsResult => {
        if(payMethodsResult.length > 0){
          this.isSavedPayments = true;
        }else{
          this.isSavedPayments = false;
        }
        this.paymentMethods = payMethodsResult;
        console.dir(this.paymentMethods);
        console.dir(payMethodsResult);
        if (this.paymentMethods.length > 0) {
          this.defaultPaymentMethod = this.paymentMethods.find((item: PaymentMethodResult) => {
            return item.ispreffered
          })
          if (!this.defaultPaymentMethod && this.paymentMethods.length > 0) {
            this.paymentMethods[0].ispreffered = true;
            this.defaultPaymentMethod = this.paymentMethods[0]
          }
          this.loading = false;
        } else {
          this.loading = false;
        }

      }, (error) => {
        this.loading = false;
      });
    })


  }


  getPlansForVisit() {

    this.loading = true;
    let plans = this.api.getPatientPoliciesByLineOfBusiness(this.patientId, this.session.intakeLob);
    plans.subscribe(response => {
      this.patientPlan = response;
      var bestPolicy = this.getBestPolicy(response);
      this.setPolicy(bestPolicy);
      if (!this.displayPayment) {
        this.selectedPlan = bestPolicy;
      }
      // if (!this.changeDetectorRef['destroyed']) {
      //   this.changeDetectorRef.detectChanges();
      // }

      this.api.getuserPaymentMethods(this.session.patientId).subscribe(payMethodsResult => {
        if(payMethodsResult.length > 0){
          this.isSavedPayments = true;
        }else{
          this.isSavedPayments = false;
        }
        this.paymentMethods = payMethodsResult;
        console.dir(this.paymentMethods);
        console.dir(payMethodsResult);
        if (this.paymentMethods.length > 0) {
          this.defaultPaymentMethod = this.paymentMethods.find((item: PaymentMethodResult) => {
            return item.ispreffered
          })
          if (!this.defaultPaymentMethod && this.paymentMethods.length > 0) {
            this.paymentMethods[0].ispreffered = true;
            this.defaultPaymentMethod = this.paymentMethods[0]
          }
          this.loading = false;
        } else {
          this.loading = false;
        }

      }, (error) => {
        this.loading = false;
      });
    })
  }
  getIntakeLOB() {
    return this.session.intakeLob;
  }

  getBestPolicy(policies: PatientPlan[]) {
    var retval;
    for (let policy of policies) {
      if (!retval || policy.visitFee < retval.visitFee) {
        retval = policy;
      }
    }

    return retval;
  }

  // onChange(event) {
  //   this.setPolicy(this.selectedPlan);
  // }
  public onChange(args: any): void {
    if(args.itemData){
      this.setPolicy(args.itemData);
      if(this.selectedPlan.visitFee > 0){
        this.displayPayment = true;
      }else{
        this.displayPayment = false;
      }
    }
   
}


  setPolicy(policy: PatientPlan) {
    this.selectedPlan = policy;
    //this.displayPayment = (this.session.intakeLob == 'BH' || (this.selectedPlan && this.selectedPlan.visitFee > 0));
  }

  getPolicyDisplay(plan: PatientPlan) {
    return (plan.name + " - $" + plan.visitFee);
  }

  changeDefault(cardOptions: PaymentMethodResult) {
    this.loading = true;
    let data = new PaymentMethod();
    data.contactfirstname = this.session.patient.profile.firstName;
    data.cardholderfirstname = cardOptions.cardholderfirstname;
    data.contactlastname = this.session.patient.profile.lastName;
    data.cardholderlastname = cardOptions.cardholderlastname;
    data.contactemail = this.session.patient.email;
    data.contactphone = this.session.patient.phoneNumber;
    data.cardnumber = cardOptions.cardnumber;
    data.cardexpirationmonth = cardOptions.cardexpirationmonth;
    data.cardexpirationyear = cardOptions.cardexpirationyear;
    data.billingzip = cardOptions.billingzip;
    data.ccv = cardOptions.ccv;
    data.active = true;
    data.ispreffered = true;
    this.api.updateUserPaymentMethods(cardOptions.cardid, data).subscribe(result => {
      this.paymentMethods = new Array<PaymentMethodResult>();
      this.api.getuserPaymentMethods(this.session.patientId).subscribe(payMethodsResult => {
        if(payMethodsResult.length > 0){
          this.isSavedPayments = true;
        }else{
          this.isSavedPayments = false;
        }
        this.paymentMethods = payMethodsResult;
        this.defaultPaymentMethod = this.paymentMethods.find((item: PaymentMethodResult) => {
          return item.ispreffered
        })
        if (!this.defaultPaymentMethod && this.paymentMethods.length > 0) {
          this.paymentMethods[0].ispreffered = true;
          this.defaultPaymentMethod = this.paymentMethods[0]
        }
        this.loading = false;
      });
    })
  }

  trim(value) {
    return value.trim();
  }

  verifyRequest(requestId): boolean {
    let verifyRequest = new RequestVerification();
    let isrequestVerified: boolean = false;
    this.api.verifyScheduledReservation(requestId).subscribe(res => {
      verifyRequest = res;
      if (verifyRequest.isValid) {
        isrequestVerified = true;
      } else {
        isrequestVerified = false;

      }
    }, (error) => {
      isrequestVerified = false;
    });
    return isrequestVerified;
  }
  continue() {

    if (this.session.intakeLob === 'BH') {
      this.proccessBHIntake();
    } else if (this.session.intakeLob === 'UC') {
      this.proccessUCIntake();
    }
  }

  proccessBHIntake() {
 
      this.loading = true;
      this.intakeWaitingRoom = new WaitingRoom();
      this.intakePayment = new IntakePaymentCharge();
      this.intakePayment.lineOfBusiness = this.session.intakeLob;
      this.intakePayment.userid = this.session.patient.userId;
      this.intakePayment.lineOfBusiness = this.session.intakeLob;
      this.intakePayment.userid = this.session.patient.userId;
      this.intakePayment.amount = "0";
      this.intakePayment.intakeid = this.session.serverIntake.intakeId.toString();
      this.intakePayment.transactiontype = 'memdzerodollar';
      this.intakePayment.intakeScheduleDate = this.session.intakeScheduleDate;
      ga('create', 'UA-25024309-1');
      ga('require', 'ecommerce');

        let _completeIntake = this.api.completeIntake(this.session.serverIntake.intakeId, this.selectedPlan.planId).map(WaitingRoom => {
          this.intakeWaitingRoom = WaitingRoom;
          this.intakeWaitingRoom.IntakeId = Number(this.session.serverIntake.intakeId);
        });


        let _processFreePayment = this.api.processUserPaymentMethod("nocard", this.intakePayment).map(zeroDollarResults => {
          console.dir(zeroDollarResults);
        })

        Observable.forkJoin([
          _completeIntake,
          _processFreePayment
        ]).subscribe(result => {
          ga('ecommerce:addTransaction', {
            'id': this.session.serverIntake.intakeId.toString(),
            'affiliation': 'MeMD:Web',
            'revenue': this.selectedPlan.visitFee.toString(),
            'shippig': '0',
            'tax': '0'
          });
          ga('ecommerce:addItem', {
            'id': this.session.serverIntake.intakeId.toString(),
            'name': 'MeMD:PatientWeb:UC',
            'sku': this.selectedPlan.planCode.toString(),
            'category': '',
            'price': this.selectedPlan.visitFee.toString(),
            'quantity': '1'
          });
          ga('ecommerce:send');

          if (this.session.scheduleReuestId && this.session.scheduleReuestId > 0) {


            this.api.confirmScheduleRequest(this.session.scheduleReuestId).subscribe(res => {
              this.loading = false;
              this.router.navigate(['thankyou/' + this.session.serverIntake.intakeId]);
            }, (error) => {
              this.loading = false;
              this.router.navigate(['thankyou/' + this.session.serverIntake.intakeId]);
            });

          } else {
            this.loading = false;
            alert('Invalid Schedule Request Id')
          }

        }, (ex) => {
          let error = this.errorHelper.toError(ex);
          if (error.errorCode = -600) {
            this.service.error(error.message);
          } else {
            this.service.error(ex);
          }
          this.loading = false;
        });
      
  }


  proccessUCIntake() {
    this.loading = true;
    this.intakePayment = new IntakePaymentCharge();
    this.intakeWaitingRoom = new WaitingRoom();
    this.intakePayment.lineOfBusiness = this.session.intakeLob;
    this.intakePayment.userid = this.session.patient.userId;
    this.intakePayment.amount = "0";
    this.intakePayment.intakeid = this.session.serverIntake.intakeId.toString();
    this.intakePayment.transactiontype = 'memdzerodollar';
    ga('create', 'UA-25024309-1');
    ga('require', 'ecommerce');

      let _completeIntake = this.api.completeIntake(this.session.serverIntake.intakeId, this.selectedPlan.planId).map(WaitingRoom => {
        this.intakeWaitingRoom = WaitingRoom;
        this.intakeWaitingRoom.IntakeId = Number(this.session.serverIntake.intakeId);
      });

      let _processFreePayment = this.api.processUserPaymentMethod("nocard", this.intakePayment).map(zeroDollarResults => {
        console.dir(zeroDollarResults);
      })

      Observable.forkJoin([
        _completeIntake,
        _processFreePayment
      ]).subscribe(result => {
        ga('ecommerce:addTransaction', {
          'id': this.session.serverIntake.intakeId.toString(),
          'affiliation': 'MeMD:Web',
          'revenue': this.selectedPlan.visitFee.toString(),
          'shippig': '0',
          'tax': '0'
        });
        ga('ecommerce:addItem', {
          'id': this.session.serverIntake.intakeId.toString(),
          'name': 'MeMD:PatientWeb:UC',
          'sku': this.selectedPlan.planCode.toString(),
          'category': '',
          'price': this.selectedPlan.visitFee.toString(),
          'quantity': '1'
        });
        ga('ecommerce:send');

        this.loading = false;
        this.router.navigate(['thankyou/' + this.session.serverIntake.intakeId]);

      }, (ex) => {
        let error = this.errorHelper.toError(ex);
        if (error.errorCode = -600) {
          this.service.error(error.message);
        } else {
          this.service.error(ex);
        }
        this.loading = false;
      });
    }
}
